export default "__VITE_ASSET__zI4rIFIr__"